var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c("span", {
      staticClass: "kt-badge kt-badge--dot kt-badge--lg align-baseline",
      class: _vm.badgeColor,
    }),
    _vm._v(" "),
    _c("span", { staticClass: "text-heading" }, [
      _vm._v(_vm._s(_vm.printValue)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }